import React from 'react';

import { ImageBannerList } from './image-banner-list';

export function ImageBanner(): JSX.Element {
  return <ImageBannerList />;
}

export default ImageBanner;
